module.exports = __webpack_public_path__ + "img/icon_editor.9bbb57c7.svg";